import React from 'react'
import styles from '../componentsStyles/Projects.module.css'
import {motion, useScroll, useTransform} from 'framer-motion'
import { useRef } from 'react'


const ProjectsHero = () => {

  const targetRef = useRef(null);

  const {scrollYProgress} = useScroll({
    target: targetRef,
    offset: ["end end","end start"]
  });

  const opacity = useTransform(scrollYProgress, 
    [0, 0.5],
    [1, 0]
  )
  const scale = useTransform(scrollYProgress,
    [0, 0.5],[1, 0.8]);

  const position = useTransform(scrollYProgress,(pos)=>{
    return pos === 1 ? "relative": "fixed"
  } )

  return (
    <motion.div className={styles.intro} 
    ref={targetRef}
    style={{opacity}}
    >
        <motion.div className={styles.textWrapper} style={{scale, position}}>
          <h2> See some of my current concluded projects</h2>
          <p> Please note that some project was made to learn new technologies and not all of those are live now.</p>
        </motion.div>
    </motion.div>
  )
}

export default ProjectsHero